<div class="">
  <div class="modal-header">
    <h4 class="modal-title kx-modal-heading pl-2">
      <strong>Registered Successfully</strong>
    </h4>
    <span class="kx-modal-close" (click)="backToList()"><i class="fa fa-close"></i></span>
  </div>
  <div class="modal-body">
    <ng-container>
      <div>
        <p>Your {{data.resource[0].uhId!=undefined?'UHID':'Pre Registration No'}} is {{data.resource[0].uhId || data.resource[0].preRegistrationNo}}</p>
      </div>
    </ng-container>
  </div>
  <div class="modal-footer justify-content-center">
    @if (checkPermissionReg()) {
      <button type="button" class="btn btn-primary" (click)="barcodeprint()">{{'button.barcode_print' | translate | async }}</button>
    }
    @if (checkPermissionReg('patient_print_QRcode')) {
      <button type="button" class="btn btn-primary" (click)="qrcodeprint()">{{'button.qrcode_print' | translate | async }}</button>
    }
    @if (checkPermission()) {
      <button type="button" class="btn btn-primary" (click)="print()">{{'button.print' | translate | async }}</button>
    }
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="backToList()">{{'button.cancel' | translate | async }}</button>
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="backToList_()">{{'button.back_to_list' | translate | async }}</button>
    @if (aadharExist) {
       <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="generateAbha('generate')">{{'button.generate_abha' | translate | async }}</button>
    }
  </div>
</div>